require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/source-map-loader/index.js!/app/src/assets/evs/js/colors.min.js"))


//////////////////
// WEBPACK FOOTER
// /app/~/script-loader!/app/src/assets/evs/js/colors.min.js
// module id = ../../../../script-loader/index.js!../../../../../src/assets/evs/js/colors.min.js
// module chunks = 6